import { Host, h } from "@stencil/core";
export class ChDropDownItemSeparator {
    render() {
        return h(Host, { role: "separator" });
    }
    static get is() { return "ch-dropdown-item-separator"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dropdown-item-separator.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dropdown-item-separator.css"]
        };
    }
}
//# sourceMappingURL=dropdown-item-separator.js.map
